import { call, put, takeLatest } from "redux-saga/effects";
import { reportNhapHocApi } from "../../../api/report/reportNhapHocApi";
import { IReportNhapHocRequest } from "../../../model/request/report/IReportNhapHocRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IReportNhapHocRespone } from "../../../model/respone/report/IReportNhapHocRespone";
import { IReportActionTypes } from "../../action-types/report/IReportActionTypes";
import { eReportNhapHocActionIds } from "../../action-types/report/IReportNhapHocActionTypes";
import { rootActions } from "../../actions/rootActions";
import { IPagingResult } from "../../../model/respone/IPagingResult";

export function* reportNhapHocSaga(): any {
  yield takeLatest(eReportNhapHocActionIds.LOAD_START, loadWorker);
  yield takeLatest(
    eReportNhapHocActionIds.EXPORT_EXCEL_BAO_CAO_START,
    exportExcelWorker
  );
}

function* loadWorker(action: IReportActionTypes): any {
  const request = action.payload as IReportNhapHocRequest;
  const res: IBaseRespone = yield call(
    reportNhapHocApi.SelectByPaging,
    request
  );
  if (res.is_success) {
    const data: IPagingResult<IReportNhapHocRespone[]> = res.data;
    yield put(rootActions.report.reportNhapHoc.LOAD_SUCCESS(data));
  } else {
    yield put(
      rootActions.report.reportNhapHoc.LOAD_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* exportExcelWorker(action: IReportActionTypes): any {
  const request = action.payload as IReportNhapHocRequest;
  const res: IBaseRespone = yield call(reportNhapHocApi.ExportExcel, request);
  if (res.is_success) {
    yield put(
      rootActions.report.reportNhapHoc.EXPORT_EXCEL_BAO_CAO_SUCCESS(res.data)
    );
  } else {
    yield put(
      rootActions.report.reportNhapHoc.EXPORT_EXCEL_BAO_CAO_ERRR(
        res?.message ?? "Thất bại"
      )
    );
  }
}
